export default "__VITE_ASSET__74f2123b__"